import gql from "graphql-tag";

export const MY_TAX_CREATE_THREE_CHILDREN_DECLARATION = gql`
  mutation createTaxDeclarationThreeChildren(
    $dateOfDeclaration: Date!
    $isModifiedDeclaration: Boolean!
    $isEligible: Boolean
    $isEligibleThree: Boolean
    $permanentlyEntitled: Boolean!
    $notApplyFromMonth: String!
    $dependents: [TaxDeclarationFourChildrenDependentInput]
  ) {
    createTaxDeclarationThreeChildren(
      dateOfDeclaration: $dateOfDeclaration
      isModifiedDeclaration: $isModifiedDeclaration
      isEligible: $isEligible
      isEligibleThree: $isEligibleThree
      permanentlyEntitled: $permanentlyEntitled
      notApplyFromMonth: $notApplyFromMonth
      dependents: $dependents
    ) {
      result
      messages
      tableId
    }
  }
`;
